/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Error_GenericInputs */

const en_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to load API keys. Please try again.`)
};

const fr_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les clés API. Veuillez réessayer.`)
};

const de_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel konnten nicht geladen werden. Bitte versuchen Sie es erneut.`)
};

const it_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le chiavi API. Riprova.`)
};

const ru_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить ключи API. Пожалуйста, попробуйте еще раз.`)
};

const es_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pueden cargar las claves API. Inténtalo de nuevo.`)
};

const zh_cn2_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API密钥加载失败，请重试。`)
};

const ja_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーを読み込めません。もう一度お試しください。`)
};

const hi_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी लोड करने में असमर्थ। कृपया पुनः प्रयास करें।`)
};

const pt_pt2_options_api_keys_error_generic = /** @type {(inputs: Options_Api_Keys_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as chaves da API. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Unable to load API keys. Please try again." |
*
* @param {Options_Api_Keys_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_error_generic = /** @type {((inputs?: Options_Api_Keys_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_error_generic(inputs)
	if (locale === "de") return de_options_api_keys_error_generic(inputs)
	if (locale === "it") return it_options_api_keys_error_generic(inputs)
	if (locale === "ru") return ru_options_api_keys_error_generic(inputs)
	if (locale === "es") return es_options_api_keys_error_generic(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_error_generic(inputs)
	if (locale === "ja") return ja_options_api_keys_error_generic(inputs)
	if (locale === "hi") return hi_options_api_keys_error_generic(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_error_generic(inputs)
	return en_options_api_keys_error_generic(inputs)
});